import { defineStore } from 'pinia';
import type { StudentRatingPerformance, StudyUnitStudyQuizPerformance } from '@/types/Performance';

export const usePerformanceStore = defineStore({
    id: 'studentPerformance',
    state: () => ({
        performance: null as StudentRatingPerformance|null,
        studyQuestions: [] as StudyUnitStudyQuizPerformance[],
    }),
    actions: {
        setPerformance(performance: StudentRatingPerformance|null) {
            this.performance = performance;
        },
        setStudyQuestions(questions: StudyUnitStudyQuizPerformance[]) {
            this.studyQuestions = questions;
        },
    },
    getters: {
        getStudentPerformance({ performance }): StudentRatingPerformance|null {
            return performance;
        },
        getStudyQuestionsPerformance({ studyQuestions }): StudyUnitStudyQuizPerformance[] {
            return studyQuestions;
        },
        getStudyQuestionsPerformanceByStudyUnit({ studyQuestions }) {
            return (id: number) => (
                studyQuestions.find((studyUnit) => studyUnit.studyUnitNumber === id) ?? null
            );
        },
        getFinalQuizPerformanceByTestSessionId({ performance }) {
            return (id: number) => (
                // eslint-disable-next-line max-len
                performance?.studyUnitPerformance.find((quiz) => (quiz.finalQuizPerformance.testSessionId === id)) ?? null
            );
        },
        getOptionalQuizPerformanceByTestSessionId({ performance }) {
            return (id: number) => (
                // eslint-disable-next-line max-len
                performance?.studyUnitPerformance.find((quiz) => (quiz.optionalQuizPerformance.testSessionId === id)) ?? null
            );
        },
        getStageTestPerformanceByTestSessionId({ performance }) {
            return (id: number) => (
                performance?.stagePerformance.find((stage) => stage.testSessionId === id) ?? null
            );
        },
        getEocTestPerformanceByTestSessionId({ performance }) {
            return (id: number) => (
                performance?.eocPerformance.testSessionId === id ? performance.eocPerformance : null
            );
        },
        getPracticeTestPerformanceByTestSessionId({ performance }) {
            return (id: number) => (
                // eslint-disable-next-line max-len
                performance?.practicePerformance.find((practice) => practice.testSessionId === id) ?? null
            );
        },
    },
});
